import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCleaningVacuum = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "cleaning-vacuum" }),
		/* @__PURE__ */ _jsx("polygon", {
			className: "a",
			points: "15.75 20.25 21.75 20.25 23.25 23.25 14.25 23.25 15.75 20.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M9.75,15.75a4.5,4.5,0,0,0-9,0v6a1.5,1.5,0,0,0,1.5,1.5h6a1.5,1.5,0,0,0,1.5-1.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M5.25,11.25V7.5a3.75,3.75,0,0,1,7.5,0v6.75a1.5,1.5,0,0,0,3,0v-12a1.5,1.5,0,0,1,3,0v18"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: .75,
			y1: 20.25,
			x2: 9.75,
			y2: 20.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M5.25,15.375a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		})
	]
});
export default SvgCleaningVacuum;
